import { useMemo } from 'react';
import { useUnlockDialogThemeContext } from '@apps/guest/packages/layout-engine/components/UnlockDialog/UnlockDialogTheme.context';
import { getButtonStylesWithAccentColor, getHoverColor, getActiveColor } from '@apps/guest/packages/layout-engine/layouts/layout.utils';
import { defaultTheme } from '@withjoy/joykit';
import chroma from 'chroma-js';

export const useUnlockDialogButtonStyles = () => {
  const { pageFontColor } = useUnlockDialogThemeContext();
  const color = pageFontColor || defaultTheme.colors.black;

  return useMemo(() => getButtonStylesWithAccentColor(color), [color]);
};

export const useUnlockDialogInputStyles = () => {
  const { pageFontColor } = useUnlockDialogThemeContext();
  const color = pageFontColor || defaultTheme.colors.black;

  return useMemo(
    () => ({
      borderColor: chroma(color).alpha(0.35).css(),
      focusColor: color,
    }),
    [color],
  );
};

// Hover styles for ghost/link-style buttons whose base color inherits from the page theme.
// JoyKit's ghost+neutral variant applies a hardcoded token on hover that ignores color="inherit",
// so we override explicitly using the same pageFontColor-derived values.
export const useUnlockDialogLinkStyles = () => {
  const { pageFontColor } = useUnlockDialogThemeContext();
  const color = pageFontColor || defaultTheme.colors.black;

  return useMemo(
    () => ({
      color,
      _hover: { color: getHoverColor(color), backgroundColor: 'transparent' },
      _active: { color: getActiveColor(color), backgroundColor: 'transparent' },
    }),
    [color],
  );
};
